import styled from "styled-components";

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px;
  gap: 32px;

  /* iPad portrait: Reduce padding slightly */
  @media (max-width: 1024px) and (min-width: 768px) {
    padding: 24px;
    gap: 24px;
  }

  /* Mobile: Reduce padding more */
  @media (max-width: 768px) {
    padding: 16px;
    gap: 24px;
  }
`;

export const BasicInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const BasicInformationHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const BasicInformationContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;   
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;

  /* iPad portrait: Keep avatar and info side by side, no wrapping */
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-wrap: nowrap;
  }

  /* Mobile: Stack avatar and info vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`

export const BasicInformationLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  align-self: center;
  flex: 0 0 auto;

  /* iPad portrait: Ensure avatar column doesn't shrink */
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-shrink: 0;
    align-self: flex-start;
  }

  /* Mobile: Center the avatar */
  @media (max-width: 768px) {
    align-self: center;
    width: 100%;
    align-items: center;
  }
`

export const BasicInformationRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  align-items: flex-start;
  align-self: stretch;
  flex: 1 1 auto;
  flex-wrap: wrap;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    flex: 0 0 auto;
    min-width: 200px;
  }

  /* iPad portrait mode: Show all content in a single column */
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
    gap: 24px;
    
    & > div {
      min-width: unset;
      width: 100%;
    }
  }

  /* Mobile: Stack everything vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    
    & > div {
      min-width: unset;
      width: 100%;
    }
  }
`

export const BasicInformationColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`

export const BasicInformationColumnItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`


export const BasicInformationContentAvatar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;  
`

export const BasicInformationContentData = styled.div`
  display: flex;
  flex-direction: row;
  gap: 80px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
  }
`

export const BasicInformationContentDataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;  
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const InfoItemRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props?.gapSpacing ? props.gapSpacing : '4px')};
  justify-content: flex-start;
  align-items: center;
`

export const LoginInformation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;   
  gap: 24px;  
`

export const LoginInformationContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;   
  gap: 12px;  
  width: 100%;  
  
  & > div {
    /* Desktop: 4 cards per row - (100% - 3 gaps * 12px) / 4 */
    flex: 0 0 calc((100% - 36px) / 4);
    min-width: 0;
    align-self: stretch;
    
    /* iPad portrait: 2 cards per row - (100% - 1 gap * 12px) / 2 */
    @media (max-width: 1024px) and (min-width: 769px) {
      flex: 0 0 calc((100% - 12px) / 2);
    }
    
    /* Tablet/Mobile: 2 cards per row - (100% - 1 gap * 12px) / 2 */
    @media (max-width: 768px) and (min-width: 481px) {
      flex: 0 0 calc((100% - 12px) / 2);
    }
    
    /* Mobile small: 1 card per row */
    @media (max-width: 480px) {
      flex: 0 0 100%;
    }
  }
`
export const LoginInformationContentCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;  
`

export const LoginInformationContentCardLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: flex-start;  
`

export const LoginInformationContentCardRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
`
export const MultiFactor = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;  
  gap: 24px;  
`

export const MultiFactorHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;  
`

export const MultiFactorState = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;  
  width: 100%;
  flex-wrap: wrap;
`

export const MultiFactorStateLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;  
`

export const MultiFactorStateRight = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px 
`

export const BasicInformationNotifications = styled.div`
    display:  ${props => props.showNotificationDisabled ? 'flex' : 'none'};
  width: 100%;
`

export const BasicInformationNotificationsInvExpired = styled.div`
  display:  ${props => props.showInvitationExpired ? 'flex' : 'none'};
  width: 100%;
`

export const BasicInformationNotificationsInvSent = styled.div`
  display:  ${props => props.showInvitationSent ? 'flex' : 'none'};
  width: 100%;
`

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  max-width: 60px;
  max-height: 60px;
`